import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AuthService } from "../../main/auth.service";
import { environment } from "../../../environments/environment";
import { ArkUserType, StatusCode, WebSiteStatusViewModel } from "../../core/api/models";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";
import { Table, TableRowCollapseEvent, TableRowExpandEvent } from "primeng/table";
import { DeveloperApiService } from "../../core/api/services";
import { DomSanitizer } from "@angular/platform-browser";
import { formatDate, formatNumber } from "@angular/common";
import moment from "moment";




@Component({
  selector: 'app-web-site-list-component',
  templateUrl: './web-site-list.component.html',
  standalone: false
})
export class WebSiteListComponent implements OnInit, AfterViewInit {



  public pageTitle: string = 'Web Sites';

  filter: any = {};
  list: any = undefined;
  loadingList: boolean = true;

  @ViewChild('dt1') table?: Table;


  loading: boolean = false;



  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiService: DeveloperApiService,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder) {
  }


  ngOnInit(): void {


    this.route.paramMap.subscribe((params: ParamMap) => {
      console.info('Loading ' , params);
    });

    this.authService.checkIfAutorized([ArkUserType.Developer, ArkUserType.Admin]);

  }

  ngAfterViewInit(): void {
  }

  loadTable(event: any) {
    if (event || !this.filter) {
      this.filter = Utils.normalizePrimeDatatableEvent(event || this.filter || { filters: {} });
    }

    this.loadingList = true;
    this.apiService.ListWebSiteStatuses({ body: this.filter })
      .forEach(
        (result) => {
          this.list = result;
          this.loadingList = false;
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loadingList = false;
          });
  }



  clear(table: Table) {
    this.table = table;
    table.clear();
  }
  getTimeFromNow(value: any): string {
    if (value === null || value === undefined)
      return '-';
    var t = new Date(value);
    // convert value from Mountain Time to local time

    const mountainTime = moment.tz(value, 'America/Denver');

    //var localTime = moment(mountainTime).utc().tz(moment.tz.guess() || 'Local');

    return mountainTime.fromNow();


    var now = new Date();
    var diff = now.getTime() - t.getTime();
    var seconds = Math.floor(diff / 1000);
    var minutes = Math.floor(seconds / 60);
    var hours = Math.floor(minutes / 60);
    var days = Math.floor(hours / 24);

    return days + 'd ' + (hours % 24) + 'h ' + (minutes % 60) + 'm';

  }



  formatByteSizeMB(value: any): string {
    if (value === null || value === undefined)
      return '-';

    return Utils.formatByteSize(value * 1024 * 1024);
  }


  GetStatusText(item: WebSiteStatusViewModel |
    null | undefined): string | null {
    if (item && !item.IsMonitored) {
      return 'Not Monitored';
    }
    if (!item || item.StatusCode === undefined || item.StatusCode === null) {
      return 'Unknown';
    }
    let status = item.StatusMessage;

    if (!status || status.length == 0) {
      switch (item.StatusCode) {
        case StatusCode.Ok:
          status = 'OK';
          break;
        case StatusCode.Fail:
          status = 'Fail';
          break;
        case StatusCode.None:
          status = 'None';
          break;
        case StatusCode.Warn:
          status = 'Warn';
          break;
        default:
          status = 'Unknown';
      }
    }

    return status;
  }

}
